import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type WohaImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};
export type WohaLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};
export type WohaPrimitiveRegistry = {
  Image: ComponentType<WohaImagePrimitiveProps>;
  Link: ComponentType<WohaLinkPrimitiveProps>;
};
export type WohaPrimitiveName = keyof WohaPrimitiveRegistry;
const Image = ({ imageClassName, priority: _priority, ...props }: WohaImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });
const Link = ({ children, rel, target, ...props }: WohaLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );
const registry: WohaPrimitiveRegistry = { Image, Link };
export function registerComponent<K extends WohaPrimitiveName>(
  name: K,
  component: WohaPrimitiveRegistry[K],
) {
  registry[name] = component;
}
export function getComponent<K extends WohaPrimitiveName>(name: K): WohaPrimitiveRegistry[K] {
  return registry[name];
}
